import { useEffect } from "react";
import { track } from "../lib/plausible";

export function Traders() {
  useEffect(() => {
    track("persona_landing_view", { persona: "trader" });
  }, []);

  return (
    <div className="max-w-3xl mx-auto px-6 py-12 space-y-10">
      <header className="space-y-3">
        <h1 className="text-3xl md:text-4xl font-semibold">
          Extract data from any stock chart — TradingView, Substack, Yahoo, broker reports
        </h1>
        <p className="text-ink/70 text-lg">
          Paste a chart screenshot. Get OHLCV data in 6 seconds. Verify visually before
          dropping into your spreadsheet or backtester.
        </p>
      </header>

      <section className="space-y-3">
        <h2 className="text-xl font-semibold">For traders who screenshot charts</h2>
        <ul className="space-y-2 text-ink/80">
          <li>· Candlestick + volume + indicator overlays → Date, Open, High, Low, Close, Volume CSV</li>
          <li>· TradingView annotation in a Substack post → extract the underlying price series</li>
          <li>· Earnings report chart on a broker PDF → spreadsheet-ready data</li>
          <li>· Log-scale long-term charts handled (S&P 30-year, BTC 2014–present, etc.)</li>
          <li>· Verification overlay re-plots extracted candles on the source chart so misreads are obvious</li>
        </ul>
      </section>

      <section className="space-y-3">
        <h2 className="text-xl font-semibold">Pricing</h2>
        <p className="text-ink/80">
          <strong>$7/mo</strong> unlimited charts, 50 MB upload limit, cancel anytime.
          14-day refund. No academic discount, no enterprise contact-sales — flat.
        </p>
      </section>

      <section className="space-y-3">
        <a
          href="/"
          onClick={() => track("persona_landing_cta", { persona: "trader" })}
          className="btn-primary inline-block"
        >
          Try it free — 5 charts/day
        </a>
        <p className="text-sm text-ink/60">
          Or see the public <a href="/accuracy" className="underline">accuracy harness</a> first.
        </p>
      </section>
    </div>
  );
}
